import { useIsDark } from '../hooks/useIsDark'
import logoSvg from '../assets/images/logo_svg.svg'

const Logo = ({ className = '', width, height, ...props }) => {
	const isDark = useIsDark()

	return (
		<img
			src={logoSvg}
			alt='Logo'
			width={width}
			height={height}
			className={className}
			style={isDark ? { filter: 'invert(1)' } : undefined}
			{...props}
		/>
	)
}

export default Logo
